import {Box} from '@mui/material';
import {styled} from '@mui/system';

import PreviewImage from '../../assets/png/preview.png';

/**
 * LiveViewContainer Component wrapper around div
 * @param {div} props
 * @return {ReactElement}
 */
export const LiveViewContainer = styled(Box,
  {shouldForwardProp: (propName) => !['hideBackground', 'isBig', 'seamless'].includes(propName)})(
  ({hideBackground, isBig, seamless, theme}) => ({
  // width: '530px',
    height: 'fit-content',
    backgroundColor: seamless ? 'inherit': 'white',
    margin: '24px 0px 24px',
    borderRadius: '8px',
    padding: '8px',
    backgroundImage: !hideBackground ? `url(${PreviewImage})` : undefined,
    backgroundSize: isBig ? 'contain' : '25%',
  }));
